import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParallax } from './effects/use-parallax';

/** Атмосфера (`section.mood` макета): параллакс-фото. */
export function Mood() {
  const { t } = useTranslation('landing');
  const sectionRef = useRef<HTMLElement>(null);
  const bgRef = useRef<HTMLDivElement>(null);
  useParallax(sectionRef, bgRef);

  return (
    <section className="mood" id="mood" ref={sectionRef}>
      <div className="bg" ref={bgRef} />
      <div className="txt rv">
        <i className="ico i-goat" />
        <h3>
          {t('mood.line1')}
          <br />
          {t('mood.line2')}
          <br />
          &amp;
          <br />
          {t('mood.line3')}
        </h3>
        <div className="orn">
          <i className="dia" />
          <i className="ico i-bows" />
          <i className="dia" />
          <i className="ico i-run" />
          <i className="dia" />
          <i className="ico i-snow" />
          <i className="dia" />
        </div>
      </div>
    </section>
  );
}
